import { render } from "./loginPageST.vue?vue&type=template&id=b96ffbe0&scoped=true"
import script from "./loginPageST.vue?vue&type=script&lang=js"
export * from "./loginPageST.vue?vue&type=script&lang=js"

import "./loginPageST.vue?vue&type=style&index=0&id=b96ffbe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96ffbe0"]])

export default __exports__